module.exports = __webpack_public_path__ + "img/20200707_103608_resized.47a0e5c9.jpg";